var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('editorial',_vm._b({attrs:{"section-style":_vm.areaSectionStyle,"actpageFullUrl":_vm.common.actpageFullUrl}},'editorial',_vm.model,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }